//@ts-nocheck
import styled from "styled-components";
import { ButtonIconPosition, ButtonSize, ButtonType } from "@xemplo/button";
import { CreatePayrunApprovers } from "@xemplo/create-payrun-approvers";
import { PayrunApproversList } from "@xemplo/payrun-approvers-list";
import { RoleRenderer } from "@xemplo/role-renderer";
import { AuthorisationModule } from "@xemplo/role-types";
import { PersonaRole } from "@xemplo/gp-types";
import { DawnAddPlus } from "@xemplo/icons";
import { useNavigate } from "react-router-dom";

interface PayrunApproverProps {
  companyId: string;
}

const List = styled(PayrunApproversList)`
  padding: 20px 0px !important;
`;

export const PayrunApprover = (props: PayrunApproverProps) => {
  const { companyId } = props;

  return (
    <RoleRenderer
      module={AuthorisationModule.payrun}
      roles={[
        PersonaRole.PSPAdmin,
        PersonaRole.PayrollManager,
        PersonaRole.SystemAdmin,
      ]}
    >
      <CreateButton {...props} />
      <List companyId={companyId} />
    </RoleRenderer>
  );
};

const CreateButton = (props: PayrunApproverProps) => {
  const navigate = useNavigate();
  return (
    <CreatePayrunApprovers
      buttonChildren="New Approver"
      buttonProps={{
        icon: <DawnAddPlus fontSize={24} />,
        iconPosition: ButtonIconPosition.Leading,
        ariaLabel: "Create new approver",
        type: ButtonType.Primary,
        size: ButtonSize.Medium,
      }}
      onSuccess={() => {
        navigate(0);
      }}
      companyId={props.companyId}
    />
  );
};
